import { Tuple } from '@skylab-shared/types';
import { ValidationRule } from './../validation-rule';
import { Validations } from './../validator';

export function getPropertyRulesFor(target: Object, propertyKey: string): Tuple<ValidationRule, any>[] {
    const objRules = getObjectRules(target);
    return objRules[propertyKey] || [];
}

export function updatePropertyRulesFor(target: Object, propertyKey: string, rules: Tuple<ValidationRule, any>[]): void {
    const objRules = getObjectRules(target);
    objRules[propertyKey] = rules;
    Reflect.defineMetadata('skl:validations', objRules, target.constructor);
}

function getObjectRules(target: Object): Validations {
    return Reflect.hasOwnMetadata('skl:validations', target.constructor)
        ? Reflect.getMetadata('skl:validations', target.constructor)
        : {};
}
